import { FC } from 'react';
import Comm100Chat from 'src/components/base-components/Chat/Comm100Chat';
import ZendeskChat from 'src/components/base-components/Chat/ZendeskChat';
import LiveChat from './LiveChat/LiveChat';
import LiveChatButton from './LiveChatButton';
import SalesforceChat from './SalesforceChat/SalesforceChat';
import TawkChat from './TawkChat';

type Prop = {
  configs: {
    type: string | number; // liveChat | zendesk
    key: any;
    imgSrc?: string;
    name?: string;
    styles?: Record<string, string>;
  };
  placement?: 'sidebar' | 'mobileFixedMenu';
};
const Chat: FC<Prop> = (props) => {
  const { placement = 'mobileFixedMenu', configs } = props;

  const chats = {
    tawkChat: <TawkChat />,
    zendesk: <ZendeskChat secretKey={configs?.key} imgSrc={configs?.imgSrc} styles={configs?.styles} />,
    salesforce: <SalesforceChat name={configs?.name} secretKey={configs?.key} />,
    liveChatButton: (
      <LiveChatButton
        settings={{
          license: configs.key,
          imgSrc: configs?.imgSrc,
        }}
        placement={placement}
      />
    ),

    liveChat: (
      <LiveChat
        settings={{
          license: configs.key,
          title: '',
          needLogin: false,
        }}
      />
    ),
    comm100: <Comm100Chat settings={{ key: configs?.key }} />,
  };

  return chats[configs?.type];
};
export default Chat;
